import "./App.css";
import { Route, Routes, Navigate, useNavigate, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Chat from "./pages/chat";
import AuthPage from "./pages/AuthPage";
import Chat2 from "./pages/chat2";
import Contact from "./pages/contact";
import TypewriterComponent from "typewriter-effect";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./ScrollToTop";
import React, { useEffect } from 'react';
import AIShowcase from "./pages/AIShowcase";
import SearchForm from "./pages/SearchForm";
import Navbar from "./components/Navbar";
import LoginModal from "./components/LoginModal.jsx";
import { AuthProvider } from "./context/AuthContext";
import BookFlight from "./pages/BookFlight";
import Test from "./pages/test";
import TestPayment from "./components/testBooking/testPayment";
import FlightBooking from "./pages/FligthBooking";
import TestComponents from "./pages/TestComponents";
import BookingHistory from "./pages/BookingHistory";
import BookingDetail from "./pages/BookingDetail";
import Home2 from "./pages/home2.jsx";
import SharedMapPage from "./pages/SharedMapPage";

const Layout = ({ children }) => {
  const location = useLocation();
  // Exclude Navbar from these paths
  const excludeNavbarPaths = ["/auth", "/search-form", "/r", "/shared-route"];
  const shouldShowNavbar = !excludeNavbarPaths.some(path =>
    location.pathname === path || location.pathname.startsWith(path + "/") || (path === "/r" && location.pathname.startsWith("/r"))
  );

  return (
    <>
      <ScrollToTop />
      {shouldShowNavbar && <Navbar />}
      {children}
      <LoginModal />
    </>
  );
};

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  // ESC closes auth route
  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape" && location.pathname === "/auth") {
        navigate("/", { replace: true });
      }
    };

    document.addEventListener("keydown", handler, true);
    return () => document.removeEventListener("keydown", handler, true);
  }, [location.pathname, navigate]);

  useEffect(() => {
    if (!window.gtagScriptLoaded) {
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://www.googletagmanager.com/gtag/js?id=G-LYGBCY5BKH";
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      function gtag() {
        window.dataLayer.push(arguments);
      }
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", "G-LYGBCY5BKH");
      window.gtagScriptLoaded = true;
    }
  }, []);

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-LYGBCY5BKH", {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return (
    <AuthProvider>
      <Layout>
        <ToastContainer />
        <Routes>
          <Route path="/" element={<Home2 />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/typetest" element={<TypewriterComponent />} />
          <Route path="/ai-test" element={<AIShowcase />} />
          <Route path="/search-form/:status?" element={<SearchForm />} />
          <Route path="/home.html" element={<Navigate to="/" />} />
          <Route path="/home" element={<Navigate to="/" />} />

          <Route path="/book-flight" element={<BookFlight />} />
          <Route path="/booking-flight" element={<FlightBooking />} />
          <Route path="/booking-history" element={<BookingHistory />} />
          <Route path="/booking-detail" element={<BookingDetail />} />

          <Route path="/test" element={<Test />} />
          <Route path="/test/components" element={<TestComponents />} />
          <Route path="/test-payment" element={<TestPayment />} />

          {/* Shared Map Dynamic Route */}
          <Route path="/r/:shortId" element={<SharedMapPage />} />
          <Route path="/shared-route" element={<SharedMapPage />} />
        </Routes>
      </Layout>
    </AuthProvider>
  );
}

export default App;

// <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//   {/* Main Content */}
//   <div className="lg:col-span-2 space-y-6">
//     <BookingReview onContactSupport={openContactModal} />
//     <TravellerDetails />
//     <FareRules onProceedToPayment={handleProceedToPayment} />
//   </div>

//   {/* Sidebar */}
//   <div className="lg:col-span-1">
//     <FareDetails />
//   </div>
// </div>
